import { env } from './env';

/** Refresh slightly before hard expiry to avoid mid-request 401s. */
export const TOKEN_EXPIRY_SKEW_MS = 60_000;

export const cognitoConfig = {
  region: env.COGNITO_REGION,
  userPoolId: env.COGNITO_USER_POOL_ID,
  clientId: env.COGNITO_CLIENT_ID,
};

export function parseJwt(token: string): Record<string, unknown> | null {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

/**
 * Whether a JWT is expired (or within `skewMs` of expiry).
 * Default skew refreshes slightly early so SPA requests avoid authorizer 401s.
 */
export function isTokenExpired(
  token: string,
  skewMs: number = TOKEN_EXPIRY_SKEW_MS
): boolean {
  const payload = parseJwt(token);
  if (!payload || typeof payload.exp !== 'number') return true;
  return Date.now() >= payload.exp * 1000 - skewMs;
}
